
var searchTypingTimer;

$(document).on('input', '.search__input', function () {
    clearTimeout(searchTypingTimer);

    var $input = $(this);

    searchTypingTimer = setTimeout(function () {
        var searchValue = $input.val();
        console.log(searchValue);

        fetch("/search?q="+searchValue+"&type=product&section_id=main-search")
            .then((res) => res.text())
            .then((data) => {
            var search__html = $(data);
            var render__html = $(".hidden-result .search__show-products", search__html);
            $(".search__main .search__show-products").replaceWith(render__html);
            var render__html = $(".hidden-result .search__btn-wrap", search__html);
            $(".search__main .search__btn-wrap").replaceWith(render__html);
            });

    }, 1000);
});